export class Name {
    constructor(data = {}) {
        var _a, _b, _c, _d, _e;
        this.salutation = (_a = data.salutation) !== null && _a !== void 0 ? _a : '';
        this.firstName = (_b = data.firstName) !== null && _b !== void 0 ? _b : '';
        this.middleName = (_c = data.middleName) !== null && _c !== void 0 ? _c : '';
        this.lastName = (_d = data.lastName) !== null && _d !== void 0 ? _d : '';
        this.fullName = (_e = data.fullName) !== null && _e !== void 0 ? _e : '';
    }
}
const nameFromString = (fullName) => {
    const names = fullName.split(' ');
    if (names.length >= 3) {
        const firstName = names[0];
        const middleName = names.slice(1, names.length - 1).join(' ');
        const lastName = names[names.length - 1];
        return {
            firstName,
            middleName,
            lastName,
            fullName,
        };
    }
    else if (names.length === 2) {
        return {
            firstName: names[0],
            middleName: null,
            lastName: names[1],
            fullName,
        };
    }
    else if (names.length === 1) {
        return {
            firstName: names[0],
            middleName: null,
            lastName: null,
            fullName,
        };
    }
    else {
        throw new Error(`Invalid name ${fullName}`);
    }
};
const fromAPI = (data = {}) => {
    return new Name({
        ...data,
    });
};
export default {
    record: Name,
    default: new Name(),
    nameFromString,
    fromAPI,
};
